import { render, staticRenderFns } from "./Exception404.vue?vue&type=template&id=d94cc5d0&scoped=true"
import script from "./Exception404.vue?vue&type=script&lang=js"
export * from "./Exception404.vue?vue&type=script&lang=js"
import style0 from "./Exception404.vue?vue&type=style&index=0&id=d94cc5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94cc5d0",
  null
  
)

export default component.exports